import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from '../../ui/button';
import { Textarea } from '../../ui/textarea';
import { Label } from '../../ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../ui/select";
import {
  getAddNotestableList,
  getNotesList,
  setPaginationFirstValue,
  setPaginationSecondValue,
  setRecordsShow,
  setIsVisible,
  // deleteNotes,
  // editNotes,
} from "./addNoteSlice";
import { bindActionCreators } from "redux";
import { getDateTimeFormate } from "../../sharedfiles/helper";
import { exportPDFC } from "../../sharedfiles/pdfExport";
import Vpagination from "../../sharedfiles/Vpagination";
// import Select_DDL from "../Common/inputs/SelectDropdown";
import { AddNotesDDL } from "../Common/data/mapData";
// import Table from '../Common/table/Table'
import { NOTE_CONSTANTS } from "../../sharedfiles/Constants";
import Tooltips from "../Common/Tooltip";
import { NoteInfo, Notes } from "../../sharedfiles/tooltipMsgs";
import NotesTable from "./AddNotesTable";
import Skelton from "../Common/skeleton/Skeleton";
class Note extends Component {
  constructor(props) {
    super(props);
    this.state = {
      category: "",
      note: "",
      id: "",
      data: {},
      error: false,
      // condition: false,
      categoryError: false,
      activePage: 1,
      totalPages: "",
      itemsPerPage: "",
      pdfBody: [],
      csvData: [],
    };
    this.onChangeCategory = this.onChangeCategory.bind(this);
    this.onChangeNote = this.onChangeNote.bind(this);
    this.mySubmitFunction = this.mySubmitFunction.bind(this);
    this.exportPDF = this.exportPDF.bind(this);
    this.updateTableToDocs = this.updateTableToDocs.bind(this);
  }

  myDocument(e) {
    this.setState({ document: e.target.value });
  }

  headers = [["Created By", "ID", "Create Time", "Category", "Text"]];


  exportPDF() {
    const title = "Add Notes Report";
    exportPDFC(title, this.pdfHeaders, this.state.pdfBody);
  }


  onChangeCategory(e) {
    if (e.target.value.length > 0) {
      this.setState({ categoryError: false });
    }
    this.setState({ category: e.target.value });
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onChangeNote(e) {
    if (e.target.value.length > 0) {
      this.setState({ error: false });
    }
    this.setState({ note: e.target.value });
  }

  callApi = (pageNumber, itemsPerPage, data) => {
    this.props.dispatch(setIsVisible(false));
    this.props.dispatch(
      getNotesList(pageNumber - 1, itemsPerPage, data)

    );
  }

  mySubmitFunction(e) {
    e.preventDefault();
    const userID = this.props.userId
      ? this.props.userId
      : localStorage.getItem("userId");
    if (this.state.note !== "" && this.state.category !== "") {
      var playerserachdata = {
        category: this.state.category,
        note: this.state.note,
      };
      this.props.dispatch(setIsVisible(false));
      this.props.dispatch(
        getAddNotestableList(localStorage.getItem("userId"), playerserachdata)
      );
      this.props.dispatch(setPaginationFirstValue(1))
      this.props.dispatch(setPaginationSecondValue(25))
      this.props.dispatch(setRecordsShow([1, 25]))
      this.setState({ category: "", note: "" });
    }
    if (this.state.note === "") {
      this.setState({ error: true });
    }
    if (this.state.category === "") {
      this.setState({ categoryError: true });
    }
  }

  componentDidMount() {
    this.props.dispatch(
      getNotesList(
        this.props.paginationFirstValue - 1,
        this.props.paginationSecondValue,
      )
    );
  }
  componentDidUpdate(prevprops) {
    const id = window.location.pathname.split("/")[2];
    if (prevprops.userId !== id) {
      this.props.dispatch(setIsVisible(false));
      this.callApi(1, 25, { id: id });
    }
    if (prevprops.notesData !== this.props.notesData) {
      this.updateTableToDocs();
    }
  }
  updateTableToDocs() {
    setTimeout(() => {
      const data = this.props?.notesData &&
        Object.keys(this.props?.notesData).length > 0 &&
        this.props.notesData?.data &&
        this.props.notesData?.data.map((elt) => [
          elt.platFormUser,
          elt.playerId,
          elt.createdDate ? getDateTimeFormate(elt.createdDate) : "-",
          elt.category,
          elt.note,
          elt.platFormUserId,
          elt.updatedById === 0 ? '-' : elt.updatedById,
          getDateTimeFormate(elt.updatedDate) || '-',
        ]);
      this.setState({ pdfBody: data });
      const cv = data.length > 0 ? [this.pdfHeaders[0], NoteInfo, ...data] : [this.pdfHeaders[0], NoteInfo, []];
      this.setState({ csvData: cv });
    }, 300);
  }
  headers = [
    { label: "Created By", key: "createdBy" },
    { label: "ID", key: "id" },
    { label: "Create Time", key: "createdDate" },
    { label: "Category", key: "category" },
    { label: "Text", key: "note" },
    { label: "Added By", key: "addedBy" },
    { label: "Updated By", key: "updateBy" },
    { label: "Updated Date", key: "updatedDate" },
  ]
  pdfHeaders = [
    [
      "Created By",
      "ID",
      "Create Time",
      "Category",
      "Text",
      "Added By",
      "Updated By",
      "Updated Date",
    ]
  ]

  render() {
    return (
      <>
        <div className='space-y-6'>
          <div className='rounded-lg border bg-card shadow-sm'>
            <div className='p-6 border-b'>
              <h2 className='text-lg font-semibold text-foreground'>Add Notes</h2>
              <p className='text-sm text-muted-foreground mt-1'>Create and manage player notes with categorization</p>
            </div>
            <div className='p-6'>
              <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4'>
                <div className='flex flex-col space-y-4'>
                  <div className='space-y-2'>
                    <Label htmlFor="noteCategory" className="flex items-center gap-2">
                      Category
                      <Tooltips info={Notes.Category} />
                    </Label>
                    <Select
                      value={this.state.category || undefined}
                      onValueChange={(value) => this.onChangeCategory({ target: { value } })}
                    >
                      <SelectTrigger
                        id="noteCategory"
                        className={this.state.categoryError ? "border-red-500" : ""}
                      >
                        <SelectValue placeholder="Select category" />
                      </SelectTrigger>
                      <SelectContent>
                        {AddNotesDDL.map((option, index) => (
                          <SelectItem key={index} value={option.value}>
                            {option.label}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                    {this.state.categoryError && (
                      <p className="text-sm text-red-500">Please select category</p>
                    )}
                  </div>
                  <div className='space-y-2'>
                    <Label htmlFor="Addnote" className="flex items-center gap-2">
                      {NOTE_CONSTANTS.notes}
                      <Tooltips info={Notes.Note} />
                    </Label>
                    <Textarea
                      id='Addnote'
                      name='note'
                      rows={3}
                      value={this.state.note}
                      onChange={this.onChangeNote}
                      placeholder="Enter your note here..."
                      className={this.state.error ? "border-red-500" : ""}
                    />
                    {this.state.error && (
                      <p className="text-sm text-red-500">
                        {NOTE_CONSTANTS.noteErr_Msg}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className='mt-6 flex justify-start'>
                <Button
                  onClick={(e) => this.mySubmitFunction(e)}
                  type='button'
                  id='addnotebtn'
                  disabled={this.props.viewOnlyuser}
                >
                  {NOTE_CONSTANTS.addNote}
                </Button>
              </div>
            </div>
          </div>

          <div className='rounded-lg border bg-card shadow-sm'>
            <div className="px-6 py-4 border-b bg-muted/20">
              <Vpagination
                data={this.props.notesData.data}
                totalRecords={this.props.notesData.totalRecords}
                paginationFirstValue={this.props.paginationFirstValue}
                paginationSecondValue={this.props.paginationSecondValue}
                setPaginationFirstValue={setPaginationFirstValue}
                setPaginationSecondValue={setPaginationSecondValue}
                recordsShow={this.props.recordsShow}
                setRecordsShow={setRecordsShow}
                isVisible={this.props.isVisible}
                setIsVisible={setIsVisible}
                csvData={this.state.csvData}
                exportPDF={this.exportPDF}
                callApi={this.callApi}
                csvFileName={"Add notes report"}
                payloadData={this.state.data}
              />
            </div>
            <div className="p-6">
              {!this.props.isVisible ? <Skelton /> : <NotesTable
                data={this.props.notesData.data}
                viewOnlyuser={this.props.viewOnlyuser}
                headers={this.headers}
              />}
            </div>
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    displayValue: state.sidebar.displayValue,
    notesData: state.addNotesSlice.notesData,
    addnoteid: state.addNotesSlice.addnoteid,
    paginationFirstValue: state.addNotesSlice.paginationFirstValue,
    paginationSecondValue: state.addNotesSlice.paginationSecondValue,
    recordsShow: state.addNotesSlice.recordsShow,
    userId: state.playersearch.userId,
    isVisible: state.addNotesSlice.isVisible,
    viewOnlyuser: state.dashboard.viewOnlyuser,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    actions: bindActionCreators({}, dispatch),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Note);